export default __webpack_public_path__ + "static/media/apple.d2bc7432.png";